<template>
  <v-row>
    shop
  </v-row>
</template>
<script>

export default {
  name: "ShopHome",
  mixins: [],
  data() {
    return {};
  },
  computed: {
    items() {
      return [

      ];
    },
  },
  mounted() {
  },
  methods: {


  },
};
</script>
<style>

</style>
